import AdapterDateFnsJalali from '@date-io/date-fns-jalali';
import { outlinedInputClasses, TextField } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { forwardRef, useImperativeHandle, useRef, useState } from 'react';

const HBAgGridCustomDatePicker = forwardRef((props: { onDateChanged: () => void }, ref) => {
  const [date, setDate] = useState<string | null>(null);

  const onDateChanged = (selectedDate: string) => {
    setDate(selectedDate);
    props.onDateChanged();
  };

  useImperativeHandle(ref, () => ({
    getDate() {
      return date;
    },

    setDate(date: string) {
      setDate(date);
    },
  }));

  return (
    <LocalizationProvider dateAdapter={AdapterDateFnsJalali}>
      <DatePicker
        inputFormat="yyyy/MM/dd"
        value={date}
        onChange={(newValue: string | null) => {
          onDateChanged(newValue || '');
        }}
        renderInput={(params) => (
          <TextField
            fullWidth
            size="small"
            {...params}
            label={''}
            sx={{
              [`& .${outlinedInputClasses.root}`]: {
                backgroundColor: 'common.white',
              },
              [`& .${outlinedInputClasses.input}`]: {
                paddingTop: 1,
                paddingBottom: 1,
              },
            }}
          />
        )}
      />
    </LocalizationProvider>
  );
});

export default HBAgGridCustomDatePicker;
